import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR as ptBRDateFns } from "date-fns/locale/pt-BR";
import { ptBR as ptBRMui } from "@mui/x-date-pickers/locales";

export function LocalizationProviderWrapper({ children }: { readonly children: React.ReactNode }) {
	return (
		<LocalizationProvider
			dateAdapter={AdapterDateFns}
			adapterLocale={ptBRDateFns}
			localeText={ptBRMui.components.MuiLocalizationProvider.defaultProps.localeText}
		>
			{children}
		</LocalizationProvider>
	);
}
